module.exports = __webpack_public_path__ + "static/media/carrito.3910c491.png";